import { useState, useEffect } from 'react';
import { X, Lightbulb } from 'lucide-react';

const TIPS_STORAGE_KEY = 'spooker_dismissed_tips';

const getDismissedTips = () => {
  try {
    return JSON.parse(localStorage.getItem(TIPS_STORAGE_KEY) || '[]');
  } catch { return []; }
};

export const ContextualTip = ({ pageKey, tip }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = getDismissedTips();
    if (!dismissed.includes(pageKey)) {
      setVisible(true);
    }
  }, [pageKey]);

  const dismiss = () => {
    setVisible(false);
    const dismissed = getDismissedTips();
    if (!dismissed.includes(pageKey)) {
      localStorage.setItem(TIPS_STORAGE_KEY, JSON.stringify([...dismissed, pageKey]));
    }
  };

  if (!visible) return null;

  return (
    <div
      className="flex items-center gap-3 px-4 py-3 rounded-xl bg-amber-50 border border-amber-100 animate-in fade-in slide-in-from-top-2 duration-500"
      data-testid={`contextual-tip-${pageKey}`}
    >
      <Lightbulb className="h-4 w-4 text-amber-500 shrink-0" strokeWidth={1.5} />
      <p className="text-sm text-amber-800 flex-1">{tip}</p>
      <button
        onClick={dismiss}
        className="text-amber-400 hover:text-amber-600 transition-colors shrink-0"
        data-testid={`dismiss-tip-${pageKey}`}
      >
        <X className="h-3.5 w-3.5" strokeWidth={2} />
      </button>
    </div>
  );
};

export const resetContextualTips = () => {
  localStorage.removeItem(TIPS_STORAGE_KEY);
};
